import { colors } from '~styles';
import styled from 'styled-components';
import { InputSelectProps } from './InputSelect.types';

export const SelectContainer = styled.div<
  Omit<InputSelectProps, 'options'> & { arrowToggle: boolean }
>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.marginTop || 0}px;
  margin-bottom: ${(props) => props.marginBottom || 0}px;

  .input-wrapper {
    display: flex;
    height: 46px;
    position: relative;
  }

  .arrow {
    width: 50px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    transition: transform 0.3s ease-out;
  }

  .active {
    transform: rotate(-180deg);
  }
`;

export const LabelContent = styled.div`
  display: flex;
  margin-bottom: 7px;
`;

export const Select = styled.select`
  width: 100%;
  height: 46px;
  border-radius: 8px;
  padding: 0px 15px;
  border: 1px solid ${colors.grayRegular};
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: ${colors.white};
  transition: color 0.3s ease-out;

  :hover {
    color: ${colors.grayRegular};
    border: 1px solid ${colors.grayMedium};
  }

  &:invalid {
    color: ${colors.grayRegular} !important;
  }
`;
